import { Component } from '@angular/core';
import { DataService } from 'src/services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  headerLogo = "./assets/img/header_desktop.svg";
  footerLogo = "./assets/img/footer_desktop.svg";
  title = 'pollPage';

  constructor(private dataService: DataService) {
    this.dataService.getHeaderLogoUrl().subscribe(result => {
      if (result && result.length > 0) {
        this.headerLogo = result;
      }
    })
    this.dataService.getFooterLogo().subscribe(result => {
      if (result && result.length > 0) {
        this.footerLogo = result;
      }
    })
  }
}
